import InfoSection from '../components/info_section';
import ScrollButton from '../components/scroll_button';
import Layout from '../components/layout';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import styles from '../styles/telemetry.module.scss';
import Link from 'next/link';
import Image from 'next/image';
import { telemetryFeaturesList } from '../constants/telemetry';
import EventsEn from '../public/services/telemetry/events_en.webp';
import EventsDetailsEn from '../public/services/telemetry/events_details_en.webp';
import NotificationsEn from '../public/services/telemetry/notifications_en.webp';
import ConfigurationsEn from '../public/services/telemetry/configurations_en.webp';
import EventsRu from '../public/services/telemetry/events_ru.webp';
import EventsDetailsRu from '../public/services/telemetry/events_details_ru.webp';
import NotificationsRu from '../public/services/telemetry/notifications_ru.webp';
import ConfigurationsRu from '../public/services/telemetry/configurations_ru.webp';
import ContactUsModal from '../components/contactUsModal';

const images = {
  en: {
    eventsTimeline: EventsEn,
    deepDive: EventsDetailsEn,
    notificationsAnywhere: NotificationsEn,
    tailoredAlerts: ConfigurationsEn,
  },
  ru: {
    eventsTimeline: EventsRu,
    deepDive: EventsDetailsRu,
    notificationsAnywhere: NotificationsRu,
    tailoredAlerts: ConfigurationsRu,
  }
};

export default function Telemetry() {
  const router = useRouter();
  const { t } = useTranslation('telemetry');

  return (
    <Layout title={t('title')} lang={router.locale} route={router.route} isHeader isFooter>
      <ScrollButton scrollStepInPx='50' delayInMs='16.66' />
      <InfoSection title='Telemetry' description='telemetryDescription' documentationLink='https://help.icdc.io/telemetry/' lang={router.locale} />

      <section className={styles.actionTracking}>
        <div>
          <h2>{t('actionTracking.title')}</h2>
          <p>{t('actionTracking.description')}</p>
        </div>
        <div>
          <Image src='/telemetry.webp' alt='Action Tracking Across Infrastructure' width={500} height={331} unoptimized loading='lazy' />
        </div>
      </section>

      <section className={styles.telemetryFeatures}>
        {telemetryFeaturesList.map((element, index) => (
          <div key={index} className={styles.telemetryFeatures__item}>
            <h3>{t(element.title)}</h3>
            <p>{t(element.description)}</p>
            <button className='btn cloud max_content' onClick={() => router.push(t(element.docsUrl))}>{t('telemetryFeatures.learnMore')}</button>
            <div className={styles.img_container}>
              <Image src={images[router.locale][element.imgUrl]} alt={t("serviceScreenshotAlt")} loading='lazy' />
            </div>
          </div>
        ))}
      </section>

      <section className={styles.launch}>
        <h2>{t('launch.title')}</h2>
        <p>{t('launch.description')}</p>
        <ContactUsModal lang={router.locale} blue />
      </section>
    </Layout>
  )
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...await serverSideTranslations(locale, ['telemetry', 'common']),
  },
});
